export const API = '/api';
